var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobileMenu = function SvgMobileMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.05 16.03"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".mobile-menu_svg__cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:2px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mobile-menu_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mobile-menu_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.05 1H0M16.05 7.97H0M16.05 15.03H0",
    className: "mobile-menu_svg__cls-1"
  })))));
};
export default SvgMobileMenu;